import gql from 'graphql-tag';

export default gql`
  fragment blastengineAutomaticMailSendMailBounceProspectActivityFragment on BlastengineAutomaticMailSendMailBounceProspectActivity {
    id
    automaticMailSend {
      step {
        name
      }
    }
    createdAt
  }
`;
